import { render, staticRenderFns } from "./PrivacyPolicyList.vue?vue&type=template&id=5c54f44f&scoped=true&"
import script from "./PrivacyPolicyList.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyList.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyList.vue?vue&type=style&index=0&id=5c54f44f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c54f44f",
  null
  
)

export default component.exports